// extracted by mini-css-extract-plugin
export var button = "quizes-module--button--DB+aa";
export var buttonsContainer = "quizes-module--buttons-container--lWiQm";
export var h1 = "quizes-module--h1--czD9W";
export var quiz = "quizes-module--quiz--FZb-l";